export const categoryList = [
  'Any Category',
  'American',
  'Classic',
  'Commuter',
  'Electric',
  'Family',
  'Fuel Efficient',
  'Hybrid',
  'Large',
  'Muscle',
  'Off Road',
  'Small',
  'Sport',
  'Supercar',
];

export const stateNames: { [key: string]: string } = {
  american: 'American',
  classic: 'Classic',
  commuter: 'Commuter',
  electric: 'Electric',
  family: 'Family',
  fuel_efficient: 'Fuel Efficient',
  hybrid: 'Hybrid',
  large: 'Large',
  muscle: 'Muscle',
  off_road: 'Off Road',
  small: 'Small',
  sport: 'Sport',
  supercar: 'Supercar',
};

export const apiNames: { [key: string]: string } = {
  American: 'american',
  Classic: 'classic',
  Commuter: 'commuter',
  Electric: 'electric',
  Family: 'family',
  'Fuel Efficient': 'fuel_efficient',
  Hybrid: 'hybrid',
  Large: 'large',
  Muscle: 'muscle',
  'Off Road': 'off_road',
  Small: 'small',
  Sport: 'sport',
  Supercar: 'supercar',
};

export function getCategoryStateName(categoryApiName: string): string {
  return stateNames[categoryApiName];
}

export function getCategoryApiName(categoryStateName: string): string {
  return apiNames[categoryStateName];
}
